import Context from "../../../../../context/Context"

function can(obj, methodName) {
  return ((typeof obj[methodName]) === "function")
}

function createErrorMessage(name) {
  const i18n = Context.instance.i18n
  return i18n.more.bookWorkspace.interfaceError.replace("{function}", name)
}

export function login(obj) {
  const name = "login"
  if (can(obj, name)) {
    return obj.login()
  } else {
    console.error(createErrorMessage(name))
  }
}

export function getAccessToken(obj) {
  const name = "getAccessToken"
  if (can(obj, name)) {
    return obj.getAccessToken()
  } else {
    console.error(createErrorMessage(name))
  }
}

export function getBookingSchedule(obj, accessToken, params) {
  const name = "getBookingSchedule"
  if (can(obj, name)) {
    return obj.getBookingSchedule(accessToken, params)
  } else {
    console.error(createErrorMessage(name))
  }
}

export function logout(obj) {
  const name = "logout"
  if (can(obj, name)) {
    return obj.logout()
  } else {
    console.error(createErrorMessage(name))
  }
}

export function getLoggedInUser(obj) {
  const name = "getLoggedInUser"
  if (can(obj, name)) {
    return obj.getLoggedInUser()
  }
  else {
    console.error(createErrorMessage(name))
  }
}

export function bookWorkspace(obj, accessToken, email, unitName, checkInDate, checkOutDate, item) {
  const name = "bookWorkspace"
  if (can(obj, name)) {
    return obj.bookWorkspace(accessToken, email, unitName, checkInDate, checkOutDate, item)
  } else {
    console.error(createErrorMessage(name))
  }
}

export function areEmailsAvailable(obj, scheduleEmails, checkIn, checkOut) {
  const name = "getLoggedInUser"
  if (can(obj, name)) {
    return obj.areEmailsAvailable(scheduleEmails, checkIn, checkOut)
  } else {
    console.error(createErrorMessage(name))
  }
}
